"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var Variable = (function () {
    function Variable(variableService, variableObject) {
        var _a;
        this.variableService = variableService;
        this._id = variableObject.id;
        this.name = variableObject.name;
        this.unitName = variableObject.unitName;
        this.defaultAmount = (_a = variableObject.defaultAmount) !== null && _a !== void 0 ? _a : 0;
        this.isDeleted = variableObject.isDeleted;
        this.ifUnder = lodash_1.default.clone(variableObject.ifUnder);
        this.ifOver = lodash_1.default.clone(variableObject.ifOver);
        this.save = lodash_1.default.throttle(this._save, 1000, { leading: true });
    }
    Variable.prototype.hasThreshold = function () {
        var _a, _b;
        return Boolean(((_a = this.ifUnder) === null || _a === void 0 ? void 0 : _a.isActive) || ((_b = this.ifOver) === null || _b === void 0 ? void 0 : _b.isActive));
    };
    Variable.prototype.getId = function () {
        return this._id;
    };
    Variable.prototype.getAmount = function (unitsAmount) {
        var _a, _b;
        if (((_a = this.ifUnder) === null || _a === void 0 ? void 0 : _a.isActive) && unitsAmount < this.ifUnder.unitThreshold) {
            return this.ifUnder.amount;
        }
        else if (((_b = this.ifOver) === null || _b === void 0 ? void 0 : _b.isActive) && unitsAmount > this.ifOver.unitThreshold) {
            return this.ifOver.amount;
        }
        else {
            return this.defaultAmount;
        }
    };
    Variable.prototype._save = function () {
        return this.variableService.updateVariable(this._id, {
            id: this._id,
            name: this.name,
            defaultAmount: this.defaultAmount,
            unitName: this.unitName,
            isDeleted: this.isDeleted,
            ifUnder: this.ifUnder,
            ifOver: this.ifOver,
        });
    };
    return Variable;
}());
exports.default = Variable;
